<template>
  <v-row>
    <v-col cols="12" sm="12" md="11" lg="11">
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Trans ID</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.journalId }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Customer</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.customerName }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>PO#</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.poNumber }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>INV#</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.invoiceNumber }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">
          <v-row>
            <v-col cols="4" sm="4" md="3" lg="3" class="py-0">
              <v-subheader>Date</v-subheader>
            </v-col>
            <v-col cols="8" sm="8" md="6" lg="6">
              {{ item.journalDate }}
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="item.listDo"
            show-expand
            :expanded.sync="expanded"
            disable-pagination
            hide-default-footer
            single-expand
            item-key="doId"
          >
            <template v-slot:item.no="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-row>
                  <v-col cols="12">PRODUCT DO</v-col>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              No
                            </th>
                            <th class="text-left">
                              Product Id
                            </th>
                            <th class="text-left">
                              Part Number
                            </th>
                            <th class="text-left">
                              Part Desc
                            </th>
                            <th class="text-left">
                              QTY
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in item.productCustomers" :key="index + 'a'">
                            <td>{{ index + 1 }}</td>
                            <td>{{ x.productId }}</td>
                            <td>{{ x.partNumber }}</td>
                            <td>{{ x.partDesc }}</td>
                            <td>{{ x.qty }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col cols="12">PRODUCT INTERNAL</v-col>
                  <v-col cols="12">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              No
                            </th>
                            <th class="text-left">
                              Product Id
                            </th>
                            <th class="text-left">
                              Part Number
                            </th>
                            <th class="text-left">
                              Part Desc
                            </th>
                            <th class="text-left">
                              QTY
                            </th>
                            <th class="text-left">
                              total
                            </th>
                            <th class="text-left">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(x, index) in item.productInternals" :key="index + 'b'">
                            <td>{{ index + 1 }}</td>
                            <td>{{ x.productId }}</td>
                            <td>{{ x.partNumber }}</td>
                            <td>{{ x.partDesc }}</td>
                            <td>{{ x.qty }}</td>
                            <td>{{ formatPrice(x.total) }}</td>
                            <td>
                              <v-btn color="success" @click="openBomList(x.items, true)"
                                ><v-icon>mdi-magnify</v-icon></v-btn
                              >
                              <v-btn
                                color="primary"
                                @click="openHoProduct(x.productId, x.poId, false)"
                                ><v-icon>mdi-eye</v-icon></v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-col>
    <v-dialog v-model="dialog" max-width="1200" persistent>
      <v-card v-if="bom">
        <v-card-title>
          <span class="headline">BOM List</span>
        </v-card-title>
        <v-card-text>
          <detail-bom-list :items="items"></detail-bom-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <v-card-title>
          <span class="headline">HO Product</span>
        </v-card-title>
        <v-card-text>
          <detail-ho-product :item="product"></detail-ho-product>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DetailBomList from "./DetailBomList.vue";
import DetailHoProduct from "./DetailHoProduct.vue";

export default {
  name: "detail-hpp",
  props: {
    item: Object,
  },
  components: {
    DetailBomList,
    DetailHoProduct,
  },
  data: () => ({
    expanded: [],
    items: [],
    product: {},
    dialog: false,
    bom: false,
    headers: [
      {
        text: "No",
        value: "no",
        sortable: false,
        divider: true,
      },
      {
        text: "DO ID",
        value: "doId",
        sortable: false,
        divider: true,
      },
      {
        text: "DO Number",
        value: "doNumber",
        sortable: false,
        divider: true,
      },
      {
        text: "RFS ID",
        value: "rfsId",
        sortable: false,
        divider: true,
      },
      {
        text: "RFS Number",
        value: "rfsNumber",
        sortable: false,
        divider: true,
      },
    ],
  }),
  methods: {
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    openBomList(items, bom) {
      this.bom = bom;
      this.items = items;
      this.dialog = true;
      // await this.$store.dispatch("inventory/getBomList", productId).then(response => {
      //   this.items = response.data;
      //   this.dialog = true;
      // });
    },
    async openHoProduct(productId, poId, bom) {
      this.bom = bom;
      await this.$store
        .dispatch("inventory/getItemHo", { productId: productId, poId: poId })
        .then(response => {
          this.product = response.data;
          this.dialog = true;
        });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style></style>
